import { GAGoalsFeaturesDataMapping } from '../constants'

export type GAGoalsFeaturesDataType = keyof typeof GAGoalsFeaturesDataMapping

export enum LockEventName {
  CTA_CLICKED = 'cta_clicked',
  LOCK_VIEW = 'lock_view',
}

/** Events sent directly to Argos as `Box.<name>`, without the GTM → box-api hop. */
export enum BoxMetricEventName {
  LOCK_CONTENT = 'LockContent',
}
